
import { ICounter } from '../Counter/types'
import { CounterType } from '../CounterType';
import { themedUseStyletron } from '../../../theme/customTheme'
import { Block } from 'baseui/block';
import { FormattedMessage } from 'react-intl';
import { SingleItem } from './SingleItem';
import { SingleItemCompare } from './SingleItemCompare';
import { defaultCurrencyCode } from '../../../utils/currency';
import { useGetCounterRates } from '../../../hooks/useGetCounterRates';



export function CostsAndCO2Panel(props: { id: any, resourceGroupId: any, counterType: CounterType, dimension: any, days: number, currencyCode: string | undefined }) {
    const [, theme] = themedUseStyletron();
    const color = theme.appColors.aggregate.off;
    const { count, co2Rates, costRates } = useGetCounterRates(props.id, props.resourceGroupId);
    const hasC02Rates = (co2Rates?.length ?? 0) > 0;
    const hasCostRates = (costRates?.length ?? 0)> 0;
    const currency = props.currencyCode ?? defaultCurrencyCode;
    return (
        <Block display='flex' flexDirection='column' alignItems='center'>
            <Block flexDirection='row' alignItems='baseline' display='flex' gridGap='5px'>
                <SingleItemCompare resourceGroupId={props.resourceGroupId} label={props.counterType === CounterType.Consumer ? <FormattedMessage id="Devices.Consumed" defaultMessage="Consumed" /> : props.counterType === CounterType.Producer ? <FormattedMessage id="Devices.Produced" defaultMessage="Produced" /> : props.counterType === CounterType.FeedOut ? <FormattedMessage id="Devices.Delivered" defaultMessage="Delivered" /> : <FormattedMessage id="Devices.Feeded" defaultMessage="Feeded" />} objectId={props.id} propertyName='valueDelta' dimension={props.dimension} type={props.counterType} days={props.days}></SingleItemCompare>
            </Block>
            <Block flexDirection='row' alignItems='baseline' display='flex' gridGap='5px'>
                {hasC02Rates && <SingleItem currencyCode={undefined} resourceGroupId={props.resourceGroupId} label={<FormattedMessage id="Devices.CO2" defaultMessage="CO2" />} color={color} objectId={props.id} propertyName='co2Consumption' dimension="kg" days={props.days}></SingleItem>}
                {hasCostRates && <SingleItem currencyCode={currency} resourceGroupId={props.resourceGroupId} label={<FormattedMessage id="Devices.Amount" defaultMessage="Amount" />} color={color} objectId={props.id} propertyName='actCostsConsumption' dimension={''} days={props.days}></SingleItem>}
            </Block>

        </Block>

    );
}

export function VirtualCounterCostsAndCO2Panel(props: { id: any, resourceGroupId: any, counterType: CounterType, dimension: any, days: number, currencyCode: string | undefined }) {
    const [, theme] = themedUseStyletron();
    const color = theme.appColors.aggregate.off;
    const currency = props.currencyCode ?? defaultCurrencyCode;
    return (
        <Block display='flex' flexDirection='column' alignItems='center'>
            <Block flexDirection='row' alignItems='baseline' display='flex' gridGap='5px'>
                <SingleItemCompare resourceGroupId={props.resourceGroupId} label={props.counterType === CounterType.Consumer ? <FormattedMessage id="Devices.Consumed" defaultMessage="Consumed" /> : props.counterType === CounterType.Producer ? <FormattedMessage id="Devices.Produced" defaultMessage="Produced" /> : props.counterType === CounterType.FeedOut ? <FormattedMessage id="Devices.Delivered" defaultMessage="Delivered" /> : <FormattedMessage id="Devices.Feeded" defaultMessage="Feeded" />} objectId={props.id} propertyName='valueDelta' dimension={props.dimension} type={props.counterType} days={props.days}></SingleItemCompare>
            </Block>
            <Block flexDirection='row' alignItems='baseline' display='flex' gridGap='5px'>
                <SingleItem currencyCode={undefined} resourceGroupId={props.resourceGroupId} label={<FormattedMessage id="Devices.CO2" defaultMessage="CO2" />} color={color} objectId={props.id} propertyName='co2Consumption' dimension="kg" days={props.days}></SingleItem>
                <SingleItem currencyCode={currency} resourceGroupId={props.resourceGroupId} label={<FormattedMessage id="Devices.Amount" defaultMessage="Amount" />} color={color} objectId={props.id} propertyName='actCostsConsumption' dimension={''} days={props.days}></SingleItem>
            </Block>

        </Block>

    );
}





